/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Priority, ProjectMember, Role, Ticket, Location } from '@touchplan/common';
import { TicketEditService } from 'src/app/modules/ticket-edit/ticket-edit.service';
import { PlanState } from 'src/app/services/plan-state.service';
import { TicketContext } from '../../ticket-context';

@Component({
	selector: 'ticket-edit-sheet',
	templateUrl: './ticket-edit-sheet.component.html',
	styleUrls: ['./ticket-edit-sheet.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketEditSheetComponent implements OnInit {
	@Input() public ticketContext: TicketContext;
	public roles$: Observable<Role[]>;
	public locations$: Observable<Location[]>;
	public projectMembers$: Observable<ProjectMember[]>;
	public priorityList$: Observable<Priority[]>;

	public ticketTitle$: Observable<string>;
	public ticket$: Observable<Ticket>;

	constructor(public ticketEditService: TicketEditService, public planState: PlanState) {
		this.ticket$ = this.ticketEditService.combinedEdit$.pipe(
			map((val) => Array.from(val.selectedList.values())[0])
		); // This might change once combinedEdit is completed for mobile
		this.roles$ = this.planState.rolesApi.data.list$.pipe(map((r) => Array.from(r.values())));
		this.locations$ = this.planState.locationsApi.data.list$.pipe(map((l) => Array.from(l.values())));
		this.projectMembers$ = this.planState.projectMembersApi.data.list$.pipe(
			map((pm) => Array.from(pm.values()))
		);
		this.priorityList$ = this.planState.priorities.list$.pipe(map((p) => Array.from(p.values())));
	}

	public ngOnInit(): void {
		// Setup the ticket title (a.k.a. description, activity name) Observable:
		this.ticketTitle$ = this.ticketEditService.combinedEdit$.pipe(map((etc) => etc.data.activityName));
	}

	public handleCloseButton() {
		this.ticketEditService.hideTicketAttachments();
	}
}
